import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';

import { RCChip } from '@reverbdotcom/cadence/components';
import { SearchRemixer_FacetGroupFieldsFragment } from '@reverbdotcom/commons/src/gql/graphql';
import { allSelectedFacets } from './facet';

type FacetChipRowProps = {
  facetGroups?: SearchRemixer_FacetGroupFieldsFragment[];
} & WithRouterProps;

export function FacetChipRow({ facetGroups = [], router }: FacetChipRowProps) {
  const facetChips = allSelectedFacets(facetGroups);

  return (
    <div className="scroll-x-on-tablet scroll-x-on-tablet--full-bleed">
      <RCChip.Collection nowrap="tablet">
        {facetChips.map((chip, idx) => {
          return (
            <RCChip
              data-testid="mobile-facet-chip"
              selected
              onClick={() => { router.replace(chip.searchUrl); }}
              key={`mobile-facet-chip-${chip.displayName}-${idx}`}
            >
              {chip.displayName}
            </RCChip>
          );
        })}
      </RCChip.Collection>
    </div>
  );
}

export default withRouter(FacetChipRow);
